export function bindCtx(ctx, fns, ns) {
  if (typeof fns === 'string') {
    fns = [fns];
  }

  // 方法的挂载空间，如果不传，默认与ctx相同
  ns = ns || ctx;
  fns.forEach(function (fnName) {
    // 这里不要添加空方法判断，由调用者保证正确性，否则出了问题无法排查
    ns[fnName] = ns[fnName].bind(ctx);
  });
}